<nav class="navbar navbar-light bg-light mx-3" [ngClass]="getNavClass()">
  <a class="navbar-brand" href="#">Vendor Portal</a>
  <button
    class="navbar-toggler" type="button" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
    (click)="toggle()">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" [collapse]="!isExpanded" [isAnimated]="true">
    <ul class="navbar-nav w-100">
      @if (userService.loggedIn) {
        <li class="nav-item" routerLinkActive="link-active" [routerLinkActiveOptions]='{ exact: true }'>
          <a class="nav-link" routerLink="/quote-side/list" (click)='collapse()'>
            <span class="glyphicon glyphicon-th-list"></span> Quote Side
          </a>
        </li>
        <li class="nav-item" routerLinkActive="link-active">
          <a class="nav-link" routerLink="/vendor-manifest/list" (click)='collapse()'>
            <span class="glyphicon glyphicon-th-list"></span> Vendor Manifest
          </a>
        </li>
        @if (isAdmin()) {
          <li class="nav-item" routerLinkActive="link-active">
            <a class="nav-link" routerLink="/vendor-management/list" (click)='collapse()'>
              <span class="glyphicon glyphicon-th-list"></span> Vendor List
            </a>
          </li>
        }
        @if (isAdmin()) {
          <li class="nav-item" routerLinkActive="link-active">
            <a class="nav-link" routerLink="/user-management/list" (click)='collapse()'>
              <span class="glyphicon glyphicon-th-list"></span> User Management
            </a>
          </li>
        }
        <li class="nav-item" routerLinkActive="link-active" [routerLinkActiveOptions]='{ exact: true }'>
          <a class="nav-link" routerLink="/communication/list" (click)='collapse()'>
            <span class="glyphicon glyphicon-th-list"></span> Communication
            @if ((unreadMessages$ | async) > 0) {
              <span class="text-danger fw-bold text-nowrap">
                {{(unreadMessages$ | async)}} New!
              </span>
            }
          </a>
        </li>
        <li class="nav-item" routerLinkActive="link-active">
          <a class="nav-link" routerLink="/consent-attachments" (click)='collapse()'>
            <span class="glyphicon glyphicon-th-list"></span> Consent Attachments
          </a>
        </li>
        @if (isAdmin()) {
          <li class="nav-item" routerLinkActive="link-active">
            <a class="nav-link" routerLink="/administration/admin-panel" (click)='collapse()'>
              <span class="glyphicon glyphicon-th-list"></span> Admin Panel
            </a>
          </li>
        }
        @if (isAdmin()) {
          <li class="nav-item" routerLinkActive="link-active">
            <a class="nav-link" routerLink="/messages/list" (click)='collapse()'>
              <span class="glyphicon glyphicon-th-list"></span> Messages
            </a>
          </li>
        }
        <li class="nav-item flex-grow-1"></li>
        <li class="nav-item text-center">
          <button
            type="button"
            class="btn btn-light ms-3 me-3"
            popover="Enable or disable email notification from the application."
            placement="bottom"
            triggers="mouseenter:mouseleave"
            (click)="switchNotification()">
            <i class="far vp-btn-icon" [ngClass]="sendNotification ? 'fa-bell' : 'fa-bell-slash not-skip'"></i>
          </button>
        </li>
        <li class="nav-item" routerLinkActive="link-active">
          <a routerLink="/common/set-password" class="nav-link" (click)='collapse()'>
            {{userService?.loggedInUser?.displayName}}
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="" class="nav-link" (click)="collapse(); logout()" href="#">Logout</a>
        </li>
      }
      <li class="nav-item" [class.ms-auto]="!userService.isLoggedIn()" [ngClass]="getRocheLogoClass()">
        <img class="roche-logo" src="assets/logo.png" alt="Roche"/>
        @if (applicationInfo$ | async; as applicationInfo) {
          <div class="app-info text-black-50">
            Version: {{applicationInfo.version}}, <br>
            {{applicationInfo.buildDate}}
          </div>
        }
      </li>
    </ul>
  </div>
</nav>
